import { Avatar, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { GenericAbortSignal } from "axios";
import { GroupItemDto, GroupItemDtoPaginatedList } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { ListChildComponentProps } from "react-window";
import { GenericListDrawer, GenericListFilter, GenericListItemsType } from "views/common/GenericListDrawer";

////////////////////////////////////////////////////////////////////////////////

type ItemData = GenericListItemsType<GroupItemDto>;

export type ListGroupsFilter = {
    searchText: string;
    pageNumber: number;
    pageSize: number;
};

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    title?: string;
    subtitle?: string;
    onGetData: (filter: ListGroupsFilter, signal: GenericAbortSignal | undefined) => Promise<GroupItemDtoPaginatedList>;
    onClose: () => void;
}

export const ListGroupsDrawer: React.FC<IPros> = (props) => {

    const { title, subtitle, onClose, onGetData } = props;
    
    const { t } = useTranslation();

    ////////////////////////////////////////////////////////////////////////////////
    
    const handleGetData = (genericFilter: GenericListFilter, signal: GenericAbortSignal | undefined): Promise<GroupItemDtoPaginatedList> => {
        return new Promise((resolve, reject) => {
            onGetData({
                ...genericFilter,
            }, signal)
            .then((response) => resolve(response))
            .catch(reject);
        });
    };

    /**
     * Renderiza uma linha da Lista.
     * @param props
     */
    // Renderiza uma linha da Lista.
    function renderRow(props: ListChildComponentProps<ItemData>) {
        const { index, style } = props;
        const { items } = props.data;

        const item = items[index];
        if (item == undefined) return <></>
        return (
            <div key={index} style={style}>
                <ListItem disablePadding disableGutters>
                    <ListItemAvatar sx={{ minWidth: 40 }}>
                        <Avatar
                            src={item.thumbnailUrl}
                            sx={(theme) => ({ width: 32, height: 32, backgroundColor: theme.palette.grey[200] })}
                        />
                    </ListItemAvatar>
                    <ListItemText
                        primary={item.name}
                        title={item.name}
                        primaryTypographyProps={{ noWrap: true, variant: "h6" }}
                    />
                </ListItem>
            </div>
        );
    }

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <GenericListDrawer
            title={title || t("Group.ListGroupsDrawer.Title")}
            subtitle={subtitle}
            itemHeight={40}
            onClose={() => onClose()}
            onGetData={handleGetData}
            emptyDataMessage={t("Group.ListGroupsDrawer.ListEmptyMessage")}
            emptyFilterMessage={t("Group.ListGroupsDrawer.NoRecordsFound")}
            renderRow={renderRow}
            selection="history"
        />
    );
};
